import { c as _c } from "react/compiler-runtime";
import type { Theme } from '@onefootprint/design-tokens';
import { createCssVariables } from '../../../../utils/get-custom-appearance/utils/create-theme';
type LoadCssVariablesProps = {
  theme: Theme;
};
const LoadCssVariables = t0 => {
  const $ = _c(4);
  const {
    theme
  } = t0;
  let t1;
  if ($[0] !== theme) {
    t1 = createCssVariables(theme);
    $[0] = theme;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cssVariables = t1;
  let t2;
  if ($[2] !== cssVariables) {
    t2 = cssVariables ? <style>{cssVariables}</style> : null;
    $[2] = cssVariables;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default LoadCssVariables;